module.exports = __webpack_public_path__ + "img/arm.d0f92910.jpg";